import React from "react";
import { Grid, Typography } from "@mui/material";
import { BIGroupingHeader } from '../../@signals'

export default function officeHeader() {

    return {
        name: 'columnName',
        setHeaderCellProps: () => ({
            sx:{
                backgroundColor: 'primary.main',
                position: 'sticky',
                top: 0,
                left: 0,
                zIndex: '160 !important',
                border: 0,
            }}),
        render: () => <Grid container>
            <Grid item xs={12} sx={{ height: '2rem', pb: 1 }} >
                <Typography sx={{ fontWeight: 'bold' }}>{BIGroupingHeader.value}</Typography>
            </Grid>
        </Grid>
    }
}